import React from 'react'

interface ProductLibraryIconProps {
    fill?: string
    stroke?: string
}
const ProductLibraryIcon = ({
    fill = '#FFFFFF',
    stroke = 'none',
}: ProductLibraryIconProps) => (
    <svg
        fill={fill}
        stroke={stroke}
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
    >
        {/* <g mask="url(#mask0_3395_1328)"> */}
        <path d="M16.2 13.05C16.2 13.392 16.011 13.689 15.723 13.842L8.613 17.838C8.469 17.946 8.289 18 8.1 18C7.911 18 7.731 17.946 7.587 17.838L0.477 13.842C0.333 13.767 0.212 13.653 0.128 13.512C0.044 13.371 0 13.212 0 13.05V4.95C0 4.608 0.189 4.311 0.477 4.158L7.587 0.162C7.731 0.054 7.911 0 8.1 0C8.289 0 8.469 0.054 8.613 0.162L15.723 4.158C16.011 4.311 16.2 4.608 16.2 4.95V13.05ZM8.1 1.935L2.736 4.95L8.1 7.965L13.464 4.95L8.1 1.935ZM1.8 12.519L7.2 15.561V9.522L1.8 6.489V12.519ZM14.4 12.519V6.489L9 9.522V15.561L14.4 12.519Z" />
        {/* </g> */}
    </svg>
)

export default ProductLibraryIcon
